import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class StatsService {

    constructor(private api: ApiService) {
    }

    getStats(query: Object): Observable<any> {
        return this.api.get('vna/stats', query);
    }

    getDashboardStats(query: Object = {}): Observable<any> {
        return this.api.get('vna/dashboard', query);
    }

    getDashboardCampaignStats(query: Object = {}): Observable<any> {
        return this.api.get('vna/dashboard/campaign', query);
    }

    getDashboardPortalVerificationStats(query: Object = {}): Observable<any> {
        return this.api.get('vna/dashboard/portal-verification', query);
    }

    getDashboardPortalEvolution(query: Object = {}): Observable<any> {
        return this.api.get('vna/dashboard/portal-evolution', query);
    }

    getDashboardLastActions(query: Object = {}): Observable<any> {
        return this.api.get('vna/dashboard/last-actions', query);
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/services/stats.service.ts